// Foundations
import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

// rxjs
import { finalize } from 'rxjs/operators';

// Services
import { AnalyticsService } from 'src/app/services/analytics.service';
import { CognitoService } from 'src/app/services/cognito.service';
import { LoadingIndicatorService } from 'src/app/services/loading-indicator.service';
import { RegisterService } from 'src/app/services/register.service';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss']
})
export class ConfirmationComponent implements OnInit {

  constructor(
    private snackBar: MatSnackBar,
    private router: Router,
    private registerService: RegisterService,
    private cognitoService: CognitoService,
    private loadingIndicatorService: LoadingIndicatorService,
    private _analytics: AnalyticsService
  ) { }

  ngOnInit(): void {
    this._analytics.logScreen('regConfirmationPage');
  }

  navigateToLandingPage(): void {
    this._analytics.logButtonTap('regConfirmation_letsGo');

    this.loadingIndicatorService.show();

    const { email, password } = this.registerService.readRegisterFormData();
    this.cognitoService.signIn({ username: email, password })
      .pipe(finalize(() => this.loadingIndicatorService.hide()))
      .subscribe(status => {
        if (status.result === 'SUCCESS') {
          this.router.navigate(['/']);
        } else {
          this.snackBar.open(status.message, '', { duration: 2000 });
        }
      });
  }

}
